import React from "react";
import "./Services.scss";

const Services = () => {
  return (
    <section id="services" className="services-section">
      <h2>What do I offer ?</h2>
      <div className="top-line"></div>
      <div className="card-wrap">
        <div className="card">
          <h4>Local Activities</h4>
          <i class="fas fa-solid fa-users fa-2x"></i>
          <p>
            Local activities and friendship clubs. Transport provided.
          </p>
        </div>
        <div className="card">
          <h4>Befriending</h4>
          <i class="fas fa-regular fa-handshake fa-2x"></i>
          <p>
            Companionship, befriending and day
            time respite for carers and loved ones
          </p>
        </div>
        <div className="card">
          <h4>Independence and Wellbeing</h4>
          <i class="fas fa-rainbow fa-2x"></i>
          <p>
            General wellbeing, shopping, exercise and trips
            out – supporting people to enjoy themselves
            and remain independent
          </p>
        </div>
        <div className="card">
          <h4>Professional care</h4>
          <i class="fas fa-user-md fa-2x"></i>
          <p>
            Experienced qualified nurse, NMC registered,
            Police DBS checked, fully insured
          </p>
        </div>

      </div>
    </section>
  );
};

export default Services;
